<template>
  <v-text-field
    v-bind="$props"
    autocomplete="new-password"
    :type="type"
    :maxlength="maxlength"
    v-on="$listeners"
  >
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
    >
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-text-field>
</template>

<script>
import { VTextField } from 'vuetify/lib';

export default {
  extends: VTextField,
  props: {
    type: {
      type: String,
      default: 'text',
    },
    maxlength: {
      type: Number,
      default: null,
    },
  },
};
</script>
